<script setup>
    import { ref, computed } from 'vue'

    const props = defineProps({
        links: {
            type: String,
            required: true
        },
        allowEdit: {
            type: Boolean,
            required: false,
            default: false
        },
        tooltip: {
            type: String,
            required: false,
            default: () => ''
        },
        language: {
            type: String,
            required: false,
            default: () => 'deutsch'
        }
    })

    const title = computed(() =>
        props.language === 'englisch' ? 'Links to additional documents | Links zu weiteren Dokumenten' : 'Links zu weiteren Dokumenten'
    )

    const emit = defineEmits(['linksSaved'])

    let editLinks = ref('')

    function handleEditStart() {
        editLinks.value = props.links
    }

    function handleEditAbort() {
        editLinks.value = ''
    }

    const saveLinks = () => {
        emit('linksSaved', editLinks.value)
    }
</script>

<template>
    <common-single-edit
        :entry="links"
        edit-key="dokumentLinks"
        :title="title"
        :tool-tip="tooltip"
        :allow-edit="allowEdit"
        @text-saved="saveLinks"
        @edit-aborted="handleEditAbort"
        @edit-started="handleEditStart"
    >
        <template #edit-component>
            <common-my-markup-editor v-model:content="editLinks" />
        </template>
        <template #preview-component>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-html="links" />
        </template>
    </common-single-edit>
</template>

<script></script>

<style scoped lang="scss"></style>
